import type IAiChatScreen from 'components/AiChat/interfaces/IAiChatScreen';
import type { IAiChatScreenLevel } from 'components/AiChat/interfaces/IAiChatScreen';

/**
 * The levels of a screen, by name: the screen first, then each sub-screen open over it in the
 * order they were opened.
 *
 * The screen is named by its label, and the first entity that carries a label names the record on
 * it — `Value Chain Map "Coffee supply chain"`. An unlabelled entity is left out: an id on its own
 * tells the assistant nothing it can use in a sentence. A sub-screen with no name to show is left
 * out too.
 */
export default function aiScreenLevels({
  label, url, entities, subScreens,
}: IAiChatScreen): IAiChatScreenLevel[] {
  const screen = label.trim();

  if (!screen) {
    return [];
  }

  const named = (entities || []).find((entity) => entity.label);
  const trail = subScreens
    .map((subScreen) => ({ name: subScreen.name.trim(), url: subScreen.url }))
    .filter((level) => level.name);

  return [{ name: named ? `${screen} "${named.label}"` : screen, url }, ...trail];
}
